import { Chip, emphasize, Grid, List as MUIList, styled } from '@mui/material';
import MUIDescriptionIcon from '@mui/icons-material/Description';
import MUIFolderIcon from '@mui/icons-material/Folder';
import AssignmentReturnIcon from '@mui/icons-material/AssignmentReturn';

export const FileBrowserHeaderContainer = styled(Grid)(({ theme }) => ({
  padding: theme.spacing(1.25, 2),
  backgroundColor: theme.palette.background.default,
  borderTop: `1px solid ${theme.palette.divider}`,
  borderBottom: `1px solid ${theme.palette.divider}`,
  color: theme.palette.text.secondary,
  '& span': {
    padding: theme.spacing(0, 0.5),
  },
}));

export const FileNameAndIconContainer = styled(Grid)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  columnGap: theme.spacing(1),
}));

export const FileIcon = styled(MUIDescriptionIcon)(({ theme }) => ({
  fontSize: '1.15rem',
  color: theme.palette.primary.main,
}));

export const FolderIcon = styled(MUIFolderIcon)(({ theme }) => ({
  fontSize: '1.15rem',
  color: theme.palette.warning.main,
}));

export const FileBrowserContainer = styled('div')(({ theme }) => ({
  rowGap: theme.spacing(2),
  display: 'flex',
  flexDirection: 'column',
  height: '100%',
}));

export const FileBrowserBackButton = styled(AssignmentReturnIcon)(
  ({ theme }) => ({
    fontSize: '1.15rem',
    color: theme.palette.text.secondary,
  }),
);

export const List = styled(MUIList)(({ theme }) => ({
  width: '100%',
  backgroundColor: theme.palette.background.paper,
  padding: 0,
}));

export const StyledBreadcrumb = styled(Chip)(({ theme }) => {
  const backgroundColor =
    theme.palette.mode === 'light'
      ? theme.palette.grey[100]
      : theme.palette.grey[800];

  return {
    backgroundColor,
    height: theme.spacing(3),
    color: theme.palette.text.primary,
    fontWeight: theme.typography.fontWeightRegular,
    '&:hover, &:focus': {
      backgroundColor: emphasize(backgroundColor, 0.06),
    },
    '&:active': {
      boxShadow: theme.shadows[1],
      backgroundColor: emphasize(backgroundColor, 0.12),
    },
  };
});
